// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { StoredNonces } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Nonce/Nonce';

const useStoredNonce: (nonce: string) => UseQueryResult<
  TemplateContract<StoredNonces> | null,
  string
> = (nonce) => {
  const ledgerApi = useLedgerApiClient();
  const { bridgeOperator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryBridgeStoredNonces', offset, ledgerApi, bridgeOperator, nonce],
    queryFn: async () => {
      return ledgerApi.queryBridgeStoredNonces(offset!, bridgeOperator, nonce);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useStoredNonce;
